import { useQuery } from '@tanstack/react-query';
import { getStripePaymentMethods, type PaymentMethodsData } from '../../api/private/getStripePaymentMethods';
import { useToken } from '../../contexts/TokenContext';

export const useGetStripePaymentMethods = () => {
  const { idToken } = useToken();

  return useQuery<PaymentMethodsData, Error>({
    queryKey: ['getStripePaymentMethods', idToken],
    queryFn: () => getStripePaymentMethods(idToken),
    enabled: false, // don't run automatically - only when manually called
    retry: false, // don't retry on authentication errors
  });
};